import * as v from "valibot"

export const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV
export const RUNTIME_NODE_JS = process.env.NEXT_RUNTIME === "nodejs"
export const RUNTIME_EDGE = process.env.NEXT_RUNTIME === "edge"

/** True only on the Vercel production deployment (main branch). */
export const IS_PRODUCTION_ENV =
  process.env.NEXT_PUBLIC_VERCEL_ENV === "production"

export const VERCEL_PROJECT_PRODUCTION_URL = new URL(
  process.env.VERCEL_PROJECT_PRODUCTION_URL
    ? `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
    : "https://near.com"
)

export const PROJECT_ID = process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID
export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL ?? ""

export const SUPABASE_URL = process.env.SUPABASE_URL
export const SUPABASE_SERVICE_ROLE_KEY = process.env.SUPABASE_SERVICE_ROLE_KEY
export const DATABASE_URL = process.env.POSTGRES_PRISMA_URL

export const INTENTS_ENV = v.parse(
  v.picklist(["production", "stage"]),
  process.env.NEXT_PUBLIC_INTENTS_ENV || "production"
)

export const CLICK_HOUSE_URL = process.env.CLICK_HOUSE_URL
export const CLICK_HOUSE_USERNAME = process.env.CLICK_HOUSE_USERNAME
export const CLICK_HOUSE_PASSWORD = process.env.CLICK_HOUSE_PASSWORD

export const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN
export const HELPSCOUT_BEACON_ID = process.env.NEXT_PUBLIC_HELPSCOUT_BEACON_ID

export const APP_FEE_BPS = v.parse(
  v.pipe(v.optional(v.string(), "0"), v.transform(Number)),
  process.env.NEXT_PUBLIC_APP_FEE_BPS
)
export const APP_CONFIDENTIAL_FEE_BPS = v.parse(
  v.pipe(v.optional(v.string(), "0"), v.transform(Number)),
  process.env.NEXT_PUBLIC_APP_CONFIDENTIAL_FEE_BPS
)
export const APP_FEE_RECIPIENT = v.parse(
  v.optional(v.string(), ""),
  process.env.NEXT_PUBLIC_APP_FEE_RECIPIENT
)
export const CONFIDENTIAL_FEE_RECIPIENT = v.parse(
  v.optional(v.string(), ""),
  process.env.NEXT_PUBLIC_CONFIDENTIAL_FEE_RECIPIENT
)

export const WITHDRAW_DIRECTION_FEE_BPS = v.parse(
  v.pipe(
    v.optional(v.string()),
    v.transform((val) => (val != null ? Number(val) : null)),
    v.nullable(v.number())
  ),
  process.env.NEXT_PUBLIC_WITHDRAW_DIRECTION_FEE_BPS
)

export const ONE_CLICK_SWAP_FRACTION =
  v.parse(
    v.pipe(
      v.optional(v.string(), "0"),
      v.transform(Number),
      v.number("NEXT_PUBLIC_ONE_CLICK_SWAP_PERCENTAGE must be a valid number"),
      v.minValue(0, "NEXT_PUBLIC_ONE_CLICK_SWAP_PERCENTAGE must be at least 0"),
      v.maxValue(
        100,
        "NEXT_PUBLIC_ONE_CLICK_SWAP_PERCENTAGE must be at most 100"
      )
    ),
    process.env.NEXT_PUBLIC_ONE_CLICK_SWAP_PERCENTAGE
  ) / 100

export const ONE_CLICK_URL = process.env.ONE_CLICK_URL
export const ONE_CLICK_API_KEY = process.env.ONE_CLICK_API_KEY
export const COINGECKO_API_KEY = process.env.COINGECKO_API_KEY
export const HEALTH_CHECK_TOKEN = process.env.HEALTH_CHECK_TOKEN

export const CRON_SECRET = process.env.CRON_SECRET

// NEXT_PUBLIC_ so client-side getAppFeeRecipient can read it. Empty when
// unset — never fall back to APP_FEE_RECIPIENT, that would mis-credit cron.
export const APP_FEE_DISTRIBUTOR =
  process.env.NEXT_PUBLIC_APP_FEE_DISTRIBUTOR || ""

export const APP_FEE_DISTRIBUTOR_RECIPIENT =
  process.env.APP_FEE_DISTRIBUTOR_RECIPIENT || ""

export const REFERRAL_PAYOUTS_CRON_DISABLED =
  process.env.REFERRAL_PAYOUTS_CRON_DISABLED === "true"

export const APP_NETWORK_OUTAGE_NOTIFICATION = v.parse(
  v.optional(v.string(), ""),
  process.env.NEXT_PUBLIC_APP_NETWORK_OUTAGE_NOTIFICATION
)

export const ONE_CLICK_JWT_PUBLIC_KEY = process.env.ONE_CLICK_JWT_PUBLIC_KEY
export const ONE_CLICK_JWT_ISSUER = process.env.ONE_CLICK_JWT_ISSUER

export const BLOB_READ_WRITE_TOKEN = process.env.BLOB_READ_WRITE_TOKEN
export const YIELD_XYZ_API_URL = process.env.YIELD_XYZ_API_URL
export const YIELD_XYZ_API_KEY = process.env.YIELD_XYZ_API_KEY
